import React, { useContext, useState } from 'react'
import CalendrierVisite from './CalendrierVisite'
import { WHITE } from '../../../theme'
import { INITIAL_POPIN_CONFIRMATION, PopinConfirmationState } from '../types/popinConfirmation'
import PopinConfirmationRDV from './PopinConfirmationRDV'
import PopinConfirmationErreurRDV from './PopinConfirmationErreurRDV'
import { CalendrierProvider } from '../context/CalendrierContext'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import { VisiteConcerneeType } from './VisitesContext'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'
import Dialog from '../../../components/dialog/Dialog'
import SwitchVisiteParking from './SwitchVisiteParking'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => ({
		popinPriseRDV: {
			'& .MuiPaper-root': {
				borderRadius: 30,
				boxShadow: 'none'
			},
			'& .MuiBackdrop-root': {
				backgroundColor: theme.palette.blue.main,
				opacity: isLargeScreen ? '0.8 !important' : 1
			}
		},
		calendrierContainer: {
			background: WHITE,
			padding: isLargeScreen ? '23px 33px 28px 35px' : '23px 25px 21px',
			borderRadius: 30,
			borderBottomRightRadius: 30,
			maxWidth: 800
		},
		popInContainerStyle: {
			padding: '31px 29px 38px 54px'
		}
	})
)

interface AcceptingProps {
	offre: VisiteConcerneeType
}

const PriseRDV: React.FC<AcceptingProps> = ({ offre }) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	const [popinConfirmation, setPopinConfirmation] = useState<PopinConfirmationState>(INITIAL_POPIN_CONFIRMATION)
	const [popinErreurConfirmation, setPopinErreurConfirmation] = useState(false)

	return (
		<Grid container item>
			<CalendrierProvider
				offre={offre}
				setPopinConfirmation={setPopinConfirmation}
				popinErreurConfirmation={popinErreurConfirmation}
				setPopinErreurConfirmation={setPopinErreurConfirmation}
			>
				{/* Switch pour visiter un parking */}
				<SwitchVisiteParking/>

				<Dialog
					onCloseDialog={() => setPopinErreurConfirmation(false)}
					open={popinErreurConfirmation}
					fullScreen={false}
					withPadding={false}
					maxWidth="lg"
					className={classes.popinPriseRDV}
				>
					<Grid container item className={classes.popInContainerStyle}>
						<PopinConfirmationErreurRDV onClose={() => {
							setPopinErreurConfirmation(false)
							window.location.reload()
						}} />

					</Grid>
				</Dialog>
				{popinConfirmation.open && (
					<PopinConfirmationRDV date={popinConfirmation.date} />
				)}
				{!popinConfirmation.open && !popinErreurConfirmation && (
					<Grid container item className={classes.calendrierContainer}>
						<CalendrierVisite />
					</Grid>
				)}
			</CalendrierProvider>
		</Grid>
	)
}

export default PriseRDV
